module.exports = __webpack_public_path__ + "static/media/16.3fc4d270.jpg";